import invariant from 'invariant';
import { createSelector } from 'reselect';
import { REVIEWS_KEY } from './constants';

const reviewsSelector = createSelector(
    state => {
        if (process.env.NODE_ENV !== 'production') {
            invariant(
                state.hasOwnProperty(REVIEWS_KEY),
                `Expected reviews to be available as \`state.${REVIEWS_KEY}\`. `
                + 'Ensure you have added the `reviewsReducer` to your store\'s '
                + 'reducers via `combineReducers`.'
            );
        }

        return state[REVIEWS_KEY];
    },
    reviews => reviews
);

export const getShowAllReviews = createSelector(
    reviewsSelector,
    reviews => reviews.showAll,
);

export default reviewsSelector;
